import { GeocodeResultModel } from './geocode-result.model';

export class GeocodeResponseModel {
  result: GeocodeResultModel;
}
